"use strict";

import moment from 'moment'

let validateSpecialRBTimer = function (event, timerHour, timerMin) {
    if (event.lgeflag == '1' && event.rbinfo.htst == '1' && (timerHour >= 1 || timerMin >= 50)) {
        return true
    }

    return false
}

export { validateSpecialRBTimer };



// WEBPACK FOOTER //
// ./resources/wob/js/common/rb-timer.js